import { render, staticRenderFns } from "./MoreDetails.vue?vue&type=template&id=3f9bfa91&scoped=true&"
import script from "./MoreDetails.vue?vue&type=script&lang=js&"
export * from "./MoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoreDetails.vue?vue&type=style&index=0&id=3f9bfa91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9bfa91",
  null
  
)

export default component.exports